<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">

        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <label>Adresy e-mail, na które będą wysyłane powiadomienia o dodaniu artykułu do zamówienia</label>
              <button @click="addEmail" class="btn btn-primary btn-sm ms-5">
                <i class="bi bi-plus-circle me-2"></i>Dodaj adres e-mail
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="table-responsive">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th>#</th>
                <th>Adres e-mail</th>
                <th>Akcje</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(email, index) in adresy_email" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input v-if="editingId === email.id" v-model="email.email" class="form-control"/>
                  <span v-else>{{ email.email }}</span>
                </td>
                <td>
                  <button v-if="editingId === email.id" @click="updateEmail(email)" class="btn btn-sm btn-success me-2">
                    Zapisz
                  </button>
                  <button v-else @click="editEmail(email.id)" class="btn btn-sm btn-outline-info me-2"><i
                      class="bi bi-pencil me-2"></i>Edytuj
                  </button>
                  <button @click="deleteEmail(email.id)" class="btn btn-sm btn-danger"><i class="bi bi-trash me-2"></i>Usuń
                  </button>
                </td>
              </tr>
              <tr v-if="addingNew">
                <td>Nowy</td>
                <td><input v-model="newEmail.email" class="form-control"/></td>
                <td>
                  <button @click="saveNewEmail" class="btn btn-sm btn-success me-1"><i class="bi bi-save me-2"></i>Zapisz
                  </button>
                  <button @click="cancelNewEmail" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout},
  props: {
    adresy_email: Array
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      newEmail: this.getEmptyForm(),
    };
  },
  methods: {
    getEmptyForm() {
      return {
        id: null,
        name: ''
      };
    },
    addEmail() {
      this.addingNew = true;
      this.newEmail = this.getEmptyForm();
    },
    cancelNewEmail() {
      this.addingNew = false;
      this.newEmail = this.getEmptyForm();
    },
    editEmail(id) {
      this.editingId = id;
    },

    updateEmail(email) {
      this.$inertia.put(route('orderLists.settings.email.update', email.id), {
        ...email,
        typ: 1,
      }, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    saveNewEmail() {
      this.$inertia.post(route('orderLists.settings.email.add'), {
        ...this.newEmail,
        typ: 1,
      }, {
        onSuccess: () => {
          this.addingNew = false;
          this.newEmail = this.getEmptyForm();
        }
      });
    },
    deleteEmail(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie adresu e-mail',
        html: 'Czy na pewno chcesz usunąć wybrany adres e-mail?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('orderLists.settings.email.delete', id));
        }
      });
    },



  }
};
</script>
